import Text from '@deprecated-ui/common/Text';
import {
  BondOrderStatus,
  BondStatusTimeline,
} from 'global/Securities/types/api/bond';
import { StepperStatus } from '../types';
import { BondOrderStatusLabelMap } from '../constants';
import TimelineItem from './TimelineItem';

interface Props {
  contents: BondStatusTimeline[];
  message?: string;
}

export default function Timeline({ contents = [], message = '' }: Props) {
  // handle the rejected content first
  const rejectedContent = contents?.find(
    (content) => content.status === BondOrderStatus.REJECTED,
  );

  if (rejectedContent) {
    return (
      <TimelineItem
        index={0}
        length={1}
        status="REJECTED"
        date={rejectedContent.occurred_at}
        label={BondOrderStatusLabelMap[rejectedContent?.status]}
        descriptions={message}
        isActive={false}
      />
    );
  }

  const statuses = [
    BondOrderStatus.SUBMITTED,
    BondOrderStatus.VERIFIED,
    BondOrderStatus.SUCCEEDED,
  ];

  const reduced = statuses.reduce((prev, current, index) => {
    let status: StepperStatus = 'UNSPECIFIED';
    let isActive = false;

    const currentContent = contents.find(
      (content) => content.status === current,
    );

    // Bond status is found in the array
    if (currentContent) {
      status = 'SUCCESS';
      isActive = true;
    } else if (prev[index - 1] && prev[index - 1].status === 'SUCCESS') {
      status = 'ON_PROGRESS';
    }

    if (currentContent && index > 0 && prev[index]) {
      status = prev[index].status === 'SUCCESS' ? 'ON_PROGRESS' : 'UNSPECIFIED';
    }

    return [
      ...prev,
      {
        index,
        status,
        length: statuses.length,
        date: currentContent?.occurred_at,
        label: BondOrderStatusLabelMap[current],
        descriptions: message,
        isActive,
      },
    ];
  }, []);

  return (
    <>
      {/* @ts-expect-error */}
      <Text family="bold" mb="16px">
        Order Status
      </Text>
      {reduced.map((item) => (
        <TimelineItem
          index={item.index}
          length={item.length}
          date={item.date}
          label={item.label}
          descriptions={item.message}
          status={item.status}
          isActive={item.isActive}
          key={`status-history-${item.index}`}
        />
      ))}
    </>
  );
}
